export const LEFTBAR_COLLAPSED_SHOW_MORE_LIMIT = 5;
export const LEFTBAR_SHOW_MORE_BUTTON_HEIGHT_PX = 20;
export const LEFTBAR_SECTION_ACTION_CLASSES =
  "-mt-px hidden items-center justify-center rounded-sm p-0.5 focus-ring-lt group-on/section-header:flex focus:outline-hidden on:bg-opposite/10";
